import { useState } from "react";
import useDownloadVideoFile from "../../../../../hooks/useDownloadVideoFile";
import Button from "../../../../../library/button";
import { Text } from "../../../../../library/text";
import { useAppSelector } from "../../../../../redux/hooks";
import { ContentWrapper } from "./styled";
import { sendErrorNotification } from "../../../../../library/notification";

interface DownloadModalProps {
  downloadUrl: string | undefined;
  onClose: () => void;
}

const DownloadModal = ({ downloadUrl, onClose }: DownloadModalProps) => {
  const [_, setProgress] = useState<number>(0);
  const video = useAppSelector((state) => state.transcript.data);
  const { downloadVideoFile } = useDownloadVideoFile();

  const clickDownload = async () => {
    try {
      if (downloadUrl) {
        await downloadVideoFile(
          downloadUrl,
          video.filename,
          setProgress,
          onClose
        );
        onClose();
      }
    } catch (e) {
      sendErrorNotification("Det oppstod en feil under nedlasting av videoen.");
      console.error(e);
    }
  };

  return (
    <ContentWrapper>
      <Text size="small" color="dark">
        Prosessen med å lage den redigerte videoen din er ferdig. Trykk på
        knappen under for å laste ned videoen din.
      </Text>
      <Button onClick={clickDownload} color="blue" variant="regular">
        Last ned video
      </Button>
    </ContentWrapper>
  );
};

export default DownloadModal;
